import { Environment } from './models/environment.model';

export const environment: Environment = {
  production: true,
  statusTimeoutMinutes: 1440, // 24 hours
};
